import { Injectable } from '@angular/core';
import DomainEventProvider from 'src/app/core/domain/events/domain_event_provider';

import { DietitianEvent } from './dietitian_events';

@Injectable({ providedIn: 'root' })
export class DietitianEventProvider extends DomainEventProvider<DietitianEvent> {}
